<template>

    <div class=" px-4 md:px-12 bg-gray-200 py-10">
        <span class="block w-full pt-1 text-xl font-semibold mb-4 tracking-wider border-orange-500" style="border-bottom-width: 1px">Announcements</span>

        <div  v-if="loading" class="flex">
            <div class=" mx-auto">
                <!-- <img alt="school logo" class="object-contain h-10 w-20" src="../images/loading.gif"> -->
                <vue-loaders
                name="ball-spin-fade-loader" color="#2a4365" class="mx-auto my-4" scale="1"></vue-loaders>
            </div>
        
        </div>
        
        <div v-else-if="announcements.length < 1">
            <h1>No announcement at the moment</h1>
        </div>

        <div v-else v-for="item in announcements" :key="item.id" class="p-4 mb-3  w-full  items-center bg-white shadow-md rounded-md">

            
            <div   class="container">


                <h1 class="flex-wrap text-base">
                    <a class="underline text-black cursor-pointer" @click="gotoDetails(item.id)">{{item.title}}</a>
                </h1>



                <p class="flex-wrap pr-4 text-gray-500 text-base font-light w-11/12 font-sans tracking-wide
                leading-loose truncate">{{item.contents}}</p>


            </div>

            <div class="flex items-center justify-between leading-none mt-2">
                <p class="pr-4 text-gray-500 font-light font-sans">Announcer: {{item.announcer}}</p>
                <p class="flex items-center pr-4 text-gray-500 font-light font-sans">{{item.created_at | formatDateSlash }}</p>
            </div>


        </div>

    </div>


</template>

<style scoped>

</style>

<script>
    import Axios from 'axios';
    // import router from "../../routes";
    // import { EditIcon, Trash2Icon, SpeakerIcon, ChevronRightIcon } from "vue-feather-icons";
    export default {
        name: "announcement",
        components: {
            // EditIcon,
            // Trash2Icon,
            // SpeakerIcon, ChevronRightIcon
        },
        data: function(){
            return {
                loading: false,
                announcements: [],
            };

        },
        // data
        methods: {
           getAnnouncements: function(){
               this.loading = true;
               let token = localStorage.getItem('token');
               if(token === null){
                   this.$router.push('/');
                   this.$swal('Pls login');
               }else{
                   Axios.get('/api/announcements',
                       {headers: {'Authorization': `Bearer ${token}`}}
                       ).then(response => {
                           this.loading = false;
                    //   console.log(response.data);
                      if(response.data.status){
                        this.announcements = response.data.data;
                      }else{
                          this.$router.push('/');
                          this.$swal('Pls login');
                      }
                   });
               }
           },
            gotoDetails: function(id){
               console.log(id);
               this.$router.push(`announce_details/${id}`);
            }
        },
        created() {
            this.getAnnouncements();
        }
    }
</script>

